import { Component } from '@angular/core';

@Component({
  selector: 'app-flip-card-front',
  template: `
  <div class="app-flip-card-front">
    <ng-content></ng-content>
  </div>
  `,
  styleUrls: ['./flip-card.component.scss'],
  standalone: false
})
export class FlipCardFrontComponent { }
